import du from '../utils/dom-utilities';

/**
 * DropdownMenu Class
 *
 * @export
 * @class DropdownMenu
 */
export class DropdownMenu {

    /**
     * Create Menu dropdown instance
     * @param {HTMLElement} $dropdownNode
     * @param {Object} customOptions - {Optional} options custom
     * @param {String} customOptions.actionSelector
     * @param {String} customOptions.classNameOpenState
     */
    constructor ($dropdownNode, customOptions = null) {
        if ( !$dropdownNode ) {
            throw new Error('dropdownNode param should be defined and an HTMLElement object');
        }
        this.options = {
            actionSelector : '.js-dropdownMenu-action',
            classNameOpenState : 'dropdownMenu--open'
        };
        if (customOptions !== null) {
            this.options = du.extend(this.options, customOptions);
        }
        this.$dropDown = $dropdownNode;
        this.$actionNode = this.$dropDown.querySelector(this.options.actionSelector);
        this.isOpen = du.parseBoolean(this.$actionNode.getAttribute('aria-expanded'));
    }

    /**
     * Open the dropDown menu. Set an event listner on document to close it
     */
    open() {
        this.isOpen = true;
        this.$dropDown.classList.add(this.options.classNameOpenState);
        this.$actionNode.setAttribute('aria-expanded', 'true');

        this._bindedCloseOnOuterClick = this._closeOnOuterClick.bind(this);
        document.addEventListener('click', this._bindedCloseOnOuterClick);
    }

    /**
     * Close the dropDown menu. Remove the event listener on document
     */
    close() {
        this.isOpen = false;
        this.$dropDown.classList.remove(this.options.classNameOpenState);
        this.$actionNode.setAttribute('aria-expanded', 'false');

        document.removeEventListener('click', this._bindedCloseOnOuterClick);
    }

    /**
     * Toggle state of the dropDown menu.
     */
    toggleState() {
        this.isOpen ? this.close() : this.open();
    }

    /**
     * Function to close drop down if user click outside the dropDown
     * @param {Event} event
     */
    _closeOnOuterClick(event) {
        if (event.target !== this.$actionNode) {
            this.close();
        }
    }

    /**
     * Initialize the the dropdown
     */
    initActionListener() {
        this.$dropDown.addEventListener('click', this.toggleState.bind(this));
    }
}

/**
 * Active the dropDown menu
 * @param {String} dropDownSelector the selector of dropDown
 * @return {DropdownMenu[]} Array of DropdownMenu instances
 */
export default function displayDropdownMenu(dropDownSelector = '.js-dropdownMenu') {
    return du.queryAll(dropDownSelector).forEach(($item) => {
        const dropDown = new DropdownMenu($item);
        dropDown.initActionListener();
        return dropDown;
    });
}



// WEBPACK FOOTER //
// ./src/main/js/components/dropdown-menu.js